import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { RootState } from "../store";
import type {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query";
const TOKEN_STORAGE_KEY = "idms_access_token";

const baseQuery = fetchBaseQuery({
 baseUrl:  process.env.REACT_APP_Everest_API_URL,
  prepareHeaders: (headers, { getState }) => {
    // Use the logged-in user's access token from Redux state, falling back to localStorage
    const state = getState() as RootState;
    const accessToken = state.auth?.token?.accessToken || localStorage.getItem(TOKEN_STORAGE_KEY);

    if (accessToken) {
      headers.set("Authorization", `Bearer ${accessToken}`);
    }
    return headers;
  },
});

const baseQueryWithCustomAuth: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);
  return result;
};

export const everestApi = createApi({
  reducerPath: "everestApi",
  baseQuery: baseQueryWithCustomAuth,
  tagTypes: ["SalesTax"],
  endpoints: () => ({}),
});
